/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Loading from '../../Loading';
import { useTranslation } from 'react-i18next';

const Favorite = () => {

    const { t } = useTranslation();
    const { BaseUrl } = useContext(MyContext);

    const [favList, setFavList] = useState([]);
    const [loading, setLoading] = useState(true);

    const Navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        
        const Userid = localStorage.getItem("Userid");
        if (Userid) {
            axios.post(`${BaseUrl}user_api/u_favlist.php`, { uid: Userid })
                .then((res) => {
                    setFavList(res.data.FavEventData);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("u_favlist", error);
                });
        }
    }, []);

    const HandleNavigate = (item) => {
        Navigate("/event-details");
        sessionStorage.setItem("Eventid", item);
    };

    return (
        <div className="width_container">
            <div className="mt-[30px]">
                <div className="mb-[20px]">
                    <h1 className='font-bold text-[30px]'>{t("Favorites")}</h1>
                    <span className='text-white'>{t("You added")} {favList?.length} {t("items to")} {t("favorites")}</span>
                </div>
                <div className="booking">
                    {favList.length >= 1
                        ? favList.map((item, index) => {
                            return <div onClick={() => HandleNavigate(item.event_id)} key={index} className="box">
                                <div className="w-[100%] h-[300px] overflow-hidden">
                                    <img src={BaseUrl + item.event_img} className="w-[100%] h-[100%] object-cover hover:scale-[1.1] duration-[0.5s]" alt="" />
                                </div>
                                <div className="px-[15px] py-[20px] bg-[#373737]">
                                    <h1 className="font-bold whitespace-nowrap overflow-hidden overflow-ellipsis text-white">{item.event_title}</h1>
                                    <p className="text-white text-[14px] mt-[10px] mb-[15px]">{item.event_place_name}</p>
                                    <div className="border-t-[1px]"></div>
                                    <div className="pt-[15px]">
                                        <h1 className="font-bold text-[14px] text-white">{item.event_sdate}</h1>
                                    </div>
                                </div>
                            </div>
                        })
                        : <div className="w-[100%] h-[300px] flex items-center justify-center">
                            <h1 className="font-bold text-gray-600">{t("Sorry, Favorite List Empty !!")}</h1>
                        </div>}
                </div>
            </div>

            {loading && <Loading />}

        </div>
    )
}

export default Favorite
/* jshint ignore:end */